import DesktopCommentInput, {
  DesktopCommentInputPassedProps,
} from 'Webapp/shared/app/components/comment-input/desktop-comment-input';
import MobileCommentInput, {
  MobileCommentInputPassedProps,
} from 'Webapp/shared/app/components/comment-input/mobile-comment-input';
import connector from 'Webapp/utils/connector';
import connectResponsive, {
  ConnectResponsiveProps,
} from 'Webapp/shared/app/connectors/connectResponsive';

type MobileCommentInputProps = ConnectResponsiveProps &
  MobileCommentInputPassedProps;
type DesktopCommentInputProps = ConnectResponsiveProps &
  DesktopCommentInputPassedProps;
type CommentInputProps = MobileCommentInputProps | DesktopCommentInputProps;

const CommentInput: React.FC<CommentInputProps> = ({ isPhone, ...props }) => {
  if (!isPhone) {
    return <DesktopCommentInput {...props} />;
  }
  return <MobileCommentInput {...props} />;
};

export default connector<CommentInputProps>(connectResponsive)(CommentInput);
